import { ReactNode } from 'react';

import { Headings, Link, ResizeAfterLoadingDiv, Text } from '@foradevelopment/fora-ui';
import { getReadablePayMonth } from '@fora-monorepo/employer-my-pages-common/utils';
import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { elementLinks, links } from '../../router/links';
import { HistoryLogFiles, ReportingActionBox, ReportingActionBoxSubSection } from '../../components';
import {
  DashboardGridSectionContentFirst,
  DashboardGridSectionContentSecond,
  DashboardGridSectionWrapper,
  DashboardSectionError,
  DashboardSectionLoading,
} from '../components/DashboardGridSection';
import { FileReportingSection } from '../components/FileReportingSection';
import { getFileDashboardMulti } from '../../redux/fileDashboard/fileDashboardThunks';
import { useTypedTranslation } from '../../i18n/i18n';

export const FileDashboardViewMulti = () => {
  const dispatch = useAppDispatch();
  const { t } = useTypedTranslation();
  const fileReportHistoryLog = useAppSelector(state => state.fileDashboard.fileDashboardMulti.fileReportHistoryLog);

  const reloadReportData = () => dispatch(getFileDashboardMulti());

  return (
    <>
      <DataLoader>
        <DashboardGridSectionWrapper>
          <DashboardGridSectionContentFirst>
            <ReportingActionBoxMulti />
          </DashboardGridSectionContentFirst>
          <DashboardGridSectionContentSecond>
            <HistoryLogFiles data={fileReportHistoryLog} title={t('section.employerOverview.latestEvents-1')} />
            <Link to={links.reportHistory}>{t('section.employerOverview.showAllEvents-1')}</Link>
            <Link to={links.payHistory}>{t('section.employeeOverview.showRegisteredPays')}</Link>
          </DashboardGridSectionContentSecond>
        </DashboardGridSectionWrapper>
      </DataLoader>
      <div id={elementLinks.fileUpload}>
        <FileReportingSection reloadReportData={reloadReportData} />
      </div>
    </>
  );
};

const ReportingActionBoxMulti = () => {
  const openReportingPeriods = useAppSelector(state => state.fileDashboard.fileDashboardMulti.openReportingPeriods);
  const { t } = useTypedTranslation();

  return (
    <ReportingActionBox variant="info">
      <ReportingActionBoxSubSection>
        {openReportingPeriods.length > 0 && (
          <Headings.H5>{t('section.employerActions.headingOpenPeriods-1')}</Headings.H5>
        )}
        {openReportingPeriods.map(({ payMonth }) => (
          <Text key={payMonth}>
            {t('section.employerActions.reportingPeriod-1', { payMonth: getReadablePayMonth(payMonth) })}
          </Text>
        ))}
      </ReportingActionBoxSubSection>
    </ReportingActionBox>
  );
};

const DataLoader = ({ children }: { children: ReactNode }) => {
  const { loadingFileDashboardMulti } = useAppSelector(state => state.fileDashboard);

  const loading = loadingFileDashboardMulti === ThunkRequestStatus.Pending;

  const error = loadingFileDashboardMulti === ThunkRequestStatus.Rejected;

  return (
    <ResizeAfterLoadingDiv initialHeight={500} isLoading={loading}>
      {loading ? <DashboardSectionLoading /> : error ? <DashboardSectionError /> : children}
    </ResizeAfterLoadingDiv>
  );
};
